<template>
  <div class="h-full d-flex flex-column justify-content-between">
    <div class="col-md-12 comments-section pt-4">
      <nav class="comments-nav flex mb-1">
        <div
          :class="[commentsSectionStep === 1 ? 'active' : '']"
          class="nav-item nav-link comments-nav-link pointer"
          @click="setCommentsStep(1)"
        >
          Comments
        </div>
        <div
          v-if="$_can('claims.logs.index')"
          :class="[commentsSectionStep === 2 ? 'active' : '']"
          class="nav-item nav-link comments-nav-link pointer"
          @click="setCommentsStep(2)"
        >
          Logs
        </div>
      </nav>

      <div class="comments-list" v-if="commentsSectionStep === 1">
        <div class="single-comment flex flex-column mb-4" v-for="note in claim.notes" :key="note.id">
          <div class="row">
            <div class="col-md-6 comment-name">
              {{ note.user.first_name }} {{ note.user.last_name }}
            </div>
            <div class="col-md-6 flex flex-justify-end comment-date">
              {{ note.date }}
            </div>
          </div>
          <div class="col-md-12 comment-note">
            <div class="comment-format">
              <read-more class="show-more" more-str="Show more" :text="note.note" less-str="Show less" :max-chars="300" />
            </div>
          </div>
        </div>
      </div>

      <logs
        v-if="commentsSectionStep === 2"
        :claim="claim"
        @refresh="$emit('update')"
      />
    </div>

    <div v-if="commentsSectionStep !== 2" class="comment-create flex justify-content-center">
      <span class="comment-area flex">
        <error-field :errors="errors" field="note" />
        <textarea v-model="comment" v-auto-resize />
        <button class="btn btn-primary" @click="saveNote" :disabled="buttonDisabled"><i class="fa fa-paper-plane" /></button>
      </span>
    </div>
  </div>
</template>
<script>
import store from 'store';
import axios from 'axios';
import toastr from 'toastr';
import Logs from './Logs';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';

export default {
  name: 'Comments',
  components: {
    Logs,
    ErrorField,
  },
  props: {
    claim: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    comment: '',
    commentsSectionStep: 1,
    buttonDisabled: false,
    errors: new Errors(),
  }),
  methods: {
    saveNote() {
      this.buttonDisabled = true;
      axios
        .post(`claims/${this.$route.params.id}/notes`, {
          note: this.comment,
          user_id: store.get('dispatchUser').id,
        })
        .then(() => {
          toastr.success('Successfully saved note');
          this.comment = '';
          this.$emit('update');
          this.errors.clear('note');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.buttonDisabled = false;
        });
    },
    setCommentsStep(step) {
      this.commentsSectionStep = step;
    },
  },
};
</script>
<style scoped>
.comment-format {
  white-space: pre-line;
}

.comments-section {
  padding: 0 24px;
  max-height: 60vh;
}

.comments-nav {
  border-bottom: solid 1px #d6dbdf;
}

.comments-nav-link {
  color: #4c5669;
  padding: 0 24px;
}

.comments-nav-link.active {
  color: #2962ff;
  border-bottom: #2962ff 1px solid;
}

.pointer {
  cursor: pointer;
}

.comments-list {
  padding-top: 26px;
  overflow-y: auto;
  height: 80vh;
}

.single-comment {
  background: #fbfbfc;
  border-radius: 4px;
  padding: 16px;
}

.comment-note {
  padding: 8px 0 0 0;
  color: #4c5669;
  word-wrap: break-word;
}

.comment-date {
  color: #808d98;
  font-size: 11px;
  font-weight: 500;
}

.comment-name {
  color: #4c5669;
  font-weight: 500;
}

.comment-create {
  background: #fff;
  padding: 17px;
  z-index: 1000;
}

.comment-area {
  width: 100%;
}

.comment-area textarea {
  width: 85%;
  border-radius: 3px;
  border: solid 1px #e0e5ea;
  background-color: rgba(243, 244, 245, 0.2);
}

.comment-area textarea::placeholder {
  padding: 12px;
  color: #616161;
}

.comment-area button {
  width: 15%;
  height: 38px;
  font-size: 21px;
  color: white;
  background: linear-gradient(to bottom, #3b73ee, #2962ff);
  border-radius: 3px;
  box-shadow: 0 1px 0 0 rgba(22, 29, 37, 0.1), inset 0 1px 0 1px rgba(255, 255, 255, 0.06);
  border: solid 1px #0f47e2;
  display: flex;
  justify-content: center;
  align-self: flex-end;
}

button.send-note:hover {
  background: #0f47e2;
}
</style>



// WEBPACK FOOTER //
// src/components/claims/Comments.vue